import { createIcon } from '~/utils';

export const XCircleIcon = createIcon({
  viewBox: '0 0 20 20',
  variant: 'stroke',
  path: [
    <path
      fill='white'
      d='M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z'
    />,
    <path
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M12.5 7.5L7.5 12.5'
    />,
    <path
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M7.5 7.5L12.5 12.5'
    />,
    <path
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z'
    />,
  ],
});
